import Styles from './Checkbox.module.css';

const Checkbox = ({ id, label, checked, extraCls = '', onChange = () => {}, disabled = false }) => {
    return (
        <div className={`${Styles.checkboxWrapper} ${extraCls}`}>
            <div className={Styles.inputWrapper}>
                <input type="checkbox" className={Styles.input} id={id} checked={checked} onChange={(event) => onChange(event.target.checked)} disabled={disabled} />
                <span className={Styles.checkmark} style={disabled ? { background: '#ccc', border: '0.1vw solid #ccc' } : {}}></span>
            </div>
            {label ? (
                <label htmlFor={id} className={Styles.label} style={disabled ? { color: '#ccc' } : {}}>
                    {label}
                </label>
            ) : null}
        </div>
    );
};

export default Checkbox;
